import { useState } from 'react';
import { useTranslations } from 'next-intl';

import { BookingRulesPopup } from '../booking-rules-popup';

export const BookingRulesContainer = () => {
	const t = useTranslations('General');
	const [isShowRules, setIsShowRules] = useState(false);

	const openRules = () => {
		setIsShowRules(true);
	};

	return (
		<>
			<div 
				className="text-link"
				onClick={openRules}
			>
				{t('lbl_ECPBBRules')}
			</div>

			{isShowRules ? (
				<BookingRulesPopup 
					isShowRules={isShowRules}
					setIsShowRules={setIsShowRules}
				/>
			) : null}
		</>
	);
};